import React from "react";
import classes from "./AnouncementBar.module.css";

export default function AnouncementBar() {
  return (
    <div className={classes.anouncementBar}>
      <h2 className={classes.anouncementBarText}>
        Alcohol Night Delivery Service 🚗
      </h2>
    </div>
  );
}
